import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class Broker {
  @JsonProperty()
  originCode: string | undefined;
  @JsonProperty()
  code: string | undefined;
  @JsonProperty()
  description: string | undefined;
  @JsonProperty()
  modificationDate: DateTime = DateTime.now();
  @JsonProperty()
  address: string | undefined;
  @JsonProperty()
  zipCode: string | undefined;
  @JsonProperty()
  town: string | undefined;
  @JsonProperty()
  country: string | undefined;
  @JsonProperty()
  currency: string | undefined;
  @JsonProperty()
  invoiceMail: string | undefined;
  @JsonProperty()
  outstandingDebt: number = 0.0;
  @JsonProperty()
  bankAccountId: number = 0;
  @JsonProperty()
  billingDueNbDays: number = 0;
  @JsonProperty()
  vatRateId: number = 0;
  @JsonProperty()
  vat: boolean = false;
  @JsonProperty()
  vatNumber: string | undefined;

}

